import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor() { 

  }

  isContactDetailsAvailable(candidate, context) {
    let candidateDetailsAvailable = true;
    let zipCode = null;
    let mobilePhone = null;

    if(context === 'candidateCard') {
      zipCode = candidate.address ? candidate.address.zipCode : null;
      mobilePhone = candidate.mobilePhone;
    } else {
      zipCode = candidate.address ? candidate.address.zipcode : null;
      mobilePhone = candidate.mobilephone;
    }

    if ((!candidate.email || candidate.email === '-')
      || (!mobilePhone || mobilePhone === '-')
      || !zipCode) {
      candidateDetailsAvailable = false;
    }
    return candidateDetailsAvailable;
  }

  isCandidateAdditionalDetailsAvailable(candidate) {
    let candidateAdditionalDetailsAvailable = true;

    if (!candidate.candidateAdditionalDetails) {
      candidateAdditionalDetailsAvailable = false;
    } else if ((
      (!candidate.candidateAdditionalDetails.preferredJobTypeDetails || candidate.candidateAdditionalDetails.preferredJobTypeDetails.jobType.length === 0)
      || (!candidate.candidateAdditionalDetails.sponsorships || candidate.candidateAdditionalDetails.sponsorships.length === 0)
      || (!candidate.candidateAdditionalDetails.workLocations || candidate.candidateAdditionalDetails.workLocations.length === 0)
      )) {
      candidateAdditionalDetailsAvailable = false;
    }

    return candidateAdditionalDetailsAvailable;
  }

  setOutreachIconStatus(outreachState) {

    const outreachSent = outreachState === 'OUTREACH_SENT';
    const outreachNoResponse = outreachState === 'OUTREACH_NO_RESPONSE_EXPIRED';
    const outreachNotCompleted = outreachState === 'OUTREACH_NOT_COMPLETED_EXPIRED';
    const outreachNotAMatch = outreachState === 'NOT_MATCHED';

    const outreachCompletedStates = [
      'OUTREACH_INTERESTED',
      'OUTREACH_NOT_INTERESTED',
      'OUTREACH_MAYBE'
    ];

    const outreachSavedStates = [
      'OUTREACH_SOFT_INTERESTED',
      'OUTREACH_SOFT_MAYBE',
      'OUTREACH_SOFT_NOT_INTERESTED'
    ];

    const outreachCompleted = outreachCompletedStates.includes(outreachState);
    const outreachSaved = outreachSavedStates.includes(outreachState);

    let tooltipMessage =
      outreachCompleted ? 'Outreach Completed'
        : outreachSaved ? 'Outreach Saved'
          : outreachNoResponse ? 'Outreach Response Expired'
            : outreachNotCompleted ? 'Outreach Completion Expired'
            : outreachNotAMatch ? 'Outreach Completed. Job is No Longer A Match'
            : 'Outreach Sent';

    return {
      outreachSent: outreachSent,
      outreachCompleted: outreachCompleted,
      outreachSaved: outreachSaved,
      outreachNoResponse: outreachNoResponse,
      outreachNotCompleted: outreachNotCompleted,
      outreachNotAMatch: outreachNotAMatch,
      outreachTooltipMessage: tooltipMessage,
      outreachIconEnabled: outreachSent || outreachCompleted || outreachSaved || outreachNoResponse || outreachNotCompleted || outreachNotAMatch
    };
  }


}
